var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "video",
    _vm._g(
      {
        ref: "video",
        staticClass: "i-video",
        attrs: {
          loop: _vm.loop,
          controls: _vm.controls,
          autoplay: _vm.autoplay,
          controlslist: "nodownload",
          playsinline: "",
          disablepictureinpicture: "",
          disableremoteplayback: "",
          "x-webkit-airplay": "deny",
        },
        domProps: { muted: _vm.muted },
        on: {
          ended: function ($event) {
            return _vm.$emit("ended", $event)
          },
          play: _vm.onTogglePause,
          pause: _vm.onTogglePause,
          seeking: _vm.onSeeking,
          volumechange: _vm.onVolumeChange,
        },
      },
      _vm.customListeners
    ),
    [_c("source", { attrs: { src: _vm.url, type: "video/mp4" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }